// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Tt-z","tooltipWrapper":"Ut-z","icon":"Vt-z","tooltip":"Wt-z","content":"Xt-z"};